export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/app/accident": [7,[3]],
		"/app/accident/[id]": [8,[3]],
		"/app/accident/[id]/detail": [9,[3]],
		"/app/accounting": [10,[3]],
		"/app/assignment": [11,[3]],
		"/app/contact": [12,[3]],
		"/app/contact/[id]": [13,[3]],
		"/app/contact/[id]/detail": [14,[3]],
		"/app/customer": [15,[3]],
		"/app/customer/[id]": [16,[3]],
		"/app/customer/[id]/detail": [17,[3]],
		"/app/customer/[id]/invoice-draft": [19,[3]],
		"/app/customer/[id]/invoice-draft/[invoiceDraftId]": [20,[3]],
		"/app/customer/[id]/invoice/[invoiceId]": [18,[3]],
		"/app/dashboard": [21,[3]],
		"/app/directory": [22,[3]],
		"/app/dispatch": [23,[3]],
		"/app/dispatch/[id]": [24,[3]],
		"/app/employee": [25,[3]],
		"/app/employee/[id]": [26,[3]],
		"/app/employee/[id]/detail": [27,[3]],
		"/app/employee/[id]/licence/[licenceId]": [28,[3]],
		"/app/facility": [29,[3]],
		"/app/facility/[id]": [30,[3]],
		"/app/facility/[id]/detail": [31,[3]],
		"/app/facility/[id]/refuel/[refuelId]": [32,[3]],
		"/app/gallery": [33,[3]],
		"/app/inbox": [34,[3]],
		"/app/invoicing/invoices": [35,[3]],
		"/app/invoicing/new-partial-invoice": [36,[3]],
		"/app/invoicing/offers": [37,[3]],
		"/app/invoicing/offers/[id]": [38,[3]],
		"/app/invoicing/offers/[id]/detail/[invoiceId]": [39,[3]],
		"/app/invoicing/offers/[id]/detail/[invoiceId]/sentInvoice": [40,[3]],
		"/app/machine": [41,[3]],
		"/app/machine/refuel": [46,[3]],
		"/app/machine/rides": [47,[3]],
		"/app/machine/[id]": [42,[3]],
		"/app/machine/[id]/detail": [43,[3]],
		"/app/machine/[id]/refuel/[refuelId]": [44,[3]],
		"/app/machine/[id]/ride/[rideId]": [45,[3]],
		"/app/notifications": [48,[3]],
		"/app/offers": [49,[3]],
		"/app/offers/[id]": [50,[3]],
		"/app/offers/[id]/detail": [51,[3]],
		"/app/operation": [52,[3]],
		"/app/orders": [53,[3]],
		"/app/orders/[id]": [54,[3]],
		"/app/reservable": [55,[3]],
		"/app/reservable/[productId]": [56,[3]],
		"/app/resources": [57,[3]],
		"/app/settings": [58,[3]],
		"/app/settings/external-api-clients": [59,[3]],
		"/app/shop": [60,[3]],
		"/app/store": [61,[3]],
		"/app/user/[id]": [62,[3]],
		"/app/warehouse": [63,[3]],
		"/app/warehouse/wuerth": [67,[3]],
		"/app/warehouse/wuerth/order/[id]": [68,[3]],
		"/app/warehouse/wuerth/receipts": [70,[3]],
		"/app/warehouse/wuerth/receipt/[id]": [69,[3]],
		"/app/warehouse/[id]": [64,[3]],
		"/app/warehouse/[id]/report": [66,[3]],
		"/app/warehouse/[id]/[itemId]": [65,[3]],
		"/error/unknown-user": [71],
		"/login": [72],
		"/new-company": [73],
		"/offer/[token]/complete": [74,[4]],
		"/offer/[token]/detail": [75,[4]],
		"/offer/[token]/info": [76,[4]],
		"/order/5e72773a-6315-4ba9-ab68-56e38ba96f30": [77],
		"/pair/[token]": [78],
		"/password-reset": [79],
		"/password-reset/email": [80],
		"/register/[token]": [81],
		"/[tenantId]/reservation": [6,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';